import { Component, Inject, PropSync, Vue } from 'vue-property-decorator'
import {
    InvoicePaymentResponse,
    InvoicePaymentStatus
} from '@/api/services/billing/invoice-payment/billing-invoice-payment.dto'
import { PaymentMethodResponse } from '@/modules/configurationModule/detail/accounting/billable/payment-method/services/payment-method.dto'
import { billingCommonPaymentMethodService } from '@/api/services/billing/common-payment-method/billing-common-payment-method.service'
import { PromiseUtils } from '@/shared/util/promise-utils'
import { Validator } from 'vee-validate'

@Component
export default class BillingModalInvoicePaymentForm extends Vue {
    @PropSync('invoicePayment', { type: Object, required: true }) syncedInvoicePayment!: InvoicePaymentResponse

    @Inject() externalValidator!: Validator

    constructor() {
        super()
        this.$validator = this.externalValidator
    }

    get invoicePaymentGenerated(): boolean {
        return this.syncedInvoicePayment?.status.code === InvoicePaymentStatus.GENERATED
    }
    get invoicePaymentCancelled(): boolean {
        return this.syncedInvoicePayment?.status.code === InvoicePaymentStatus.CANCELLED
    }
    get invoicePaymentVerified(): boolean {
        return this.syncedInvoicePayment?.status.code === InvoicePaymentStatus.VERIFIED
    }

    async getAllActivePaymentMethods(): Promise<PaymentMethodResponse[]> {
        const response =
            await PromiseUtils.toCallSecure(
                billingCommonPaymentMethodService.getAllActivePaymentMethods())
        return response ?? []
    }
}
